/* Two-leg sign-in and invitation shapes. Hand-typed to m6-rulings.md #105, #110, #112
   ("Auth" pinned shapes) until the access lane's schema.d.ts regenerates them. */

import type { LoginResponse, Role, Surface } from "./types";

export type Membership = { entityId: string; legalName: string; role: Role };

export type AuthSession = LoginResponse & { status: "ok"; portalEntityId: string | null };

export type MfaChallenge = { status: "mfa_required"; challenge: string; memberships: Membership[] };
export type EnrolmentChallenge = {
  status: "mfa_enrolment_required";
  challenge: string;
  secret: string;
  otpauthUrl: string;
  memberships: Membership[];
};
export type EntityChoiceChallenge = { status: "entity_choice_required"; challenge: string; memberships: Membership[] };

export type Challenge = MfaChallenge | EnrolmentChallenge | EntityChoiceChallenge;

/** `POST /api/auth/login` and `POST /api/auth/accept-invite` both answer this union on `status`. */
export type LoginOutcome = AuthSession | Challenge;
/** m6-rulings.md #150: an invitation can land on an existing account, so accept-invite answers the full union. */
export type AcceptInviteOutcome = LoginOutcome;

export type LoginRequest = { email: string; password: string };
export type MfaRequest = { challenge: string; code?: string; entityId?: string };
export type AcceptInviteRequest = { token: string; displayName: string; password: string };

/** `GET /api/auth/providers`: one "Sign in with {name}" button per item; empty without SSO (ruling 134). */
export type ProviderCard = { key: string; name: string };
export type ProviderList = { items: ProviderCard[] };
/** The `#oidc=` fragment the callback hands `/signin`; spent once at `POST /api/auth/oidc/complete` (ruling 161). */
export type HandoffRequest = { handoff: string };

export const MIN_PASSWORD_LENGTH = 12;

export function homeFor(surface: Surface): string {
  return surface === "portal" ? "/portal" : "/";
}
